export enum UserEventTypeEnum {
    JobMatchPageView = 1,
    JobAlertsView = 2
}
